import { Masks } from "@hooks/functions/Masks/Masks";
import React, { useState } from "react";

import { FiEye, FiEyeOff } from "react-icons/fi";

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  showLabel?: boolean;
  animated?: boolean;
  placeholder?: string;
  mask?: "phone" | "cpf" | "cnpj" | "cep" | "data" | "milhar";
  register?: any;
  errorMessage?: string;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => void;
}

const masks = new Masks();
export function Input({
  label,
  showLabel,
  placeholder,
  className,
  animated,
  register,
  mask,
  type,
  errorMessage,
  onChange,
  ...rest
}: IProps) {
  const [showPassword, setShowPassword] = useState(false);
  const maskObj = {
    phone: masks.phone,
    cpf: masks.cpf,
    cnpj: masks.cnpj,
    cep: masks.postalCode,
    data: masks.date,
    milhar: masks.formatMilhar,
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (mask && maskObj[mask]) {
      if (mask === "milhar") {
        const numericValue =
          parseFloat(e.target.value.replace(/\D/g, "")) || 0;
        e.target.value = masks.formatMilhar(numericValue);
      } else {
        e.target.value = maskObj[mask](e.target.value);
      }
    }

    register?.onChange?.(e);
    if (onChange) onChange(e);
  };

  return (
    <>
      {animated ? (
        <div className={`form-floating ${className} input-${type}`}>
          <input
            className={`form-control ${errorMessage ? "is-invalid" : ""}`}
            placeholder={placeholder}
            style={type === "password" ? { paddingRight: "3rem" } : undefined}
            type={
              type === "password" && showPassword ? "text" : (type ?? "text")
            }
            {...register}
            {...rest}
            onChange={handleInputChange}
          />
          {errorMessage && (
            <div className="invalid-feedback">{errorMessage}</div>
          )}

          <label>{label}</label>
          {type === "password" && (
            <button
              type="button"
              className="border-0 bg-transparent d-flex align-items-center justify-content-center"
              disabled={rest.disabled}
              style={{
                position: "absolute",
                top: "50%",
                right: "0.75rem",
                transform: "translateY(-50%)",
                zIndex: 5,
                width: "2rem",
                height: "2rem",
                color: "#6c757d",
              }}
              onClick={() => {
                setShowPassword(!showPassword);
              }}
            >
              {showPassword ? <FiEye /> : <FiEyeOff />}
            </button>
          )}
        </div>
      ) : (
        <div>
          {label && <label className="form-label">{label}</label>}

          <div
            className={`${className} input-${type}`}
            style={type === "password" ? { position: "relative" } : undefined}
          >
            <input
              className={`form-control ${errorMessage ? "is-invalid" : ""}`}
              placeholder={placeholder}
              style={
                type === "password" ? { paddingRight: "3rem" } : undefined
              }
              type={
                type === "password" && showPassword ? "text" : (type ?? "text")
              }
              {...register}
              {...rest}
              onChange={handleInputChange}
            />

            {errorMessage && (
              <div className="invalid-feedback">{errorMessage}</div>
            )}

            {type === "password" && (
              <button
                type="button"
                className="border-0 bg-transparent d-flex align-items-center justify-content-center"
                disabled={rest.disabled}
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "0.75rem",
                  transform: "translateY(-50%)",
                  zIndex: 5,
                  width: "2rem",
                  height: "2rem",
                  color: "#6c757d",
                }}
                onClick={() => {
                  setShowPassword(!showPassword);
                }}
              >
                {showPassword ? <FiEye /> : <FiEyeOff />}
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
}
